import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    jobCardReportNormalLists: {
        isLoading: false,
        isLoadingMore: false,
        dataLoaded: false,
        data: null,
        totalRecords: 0,
        recordCounts: 0,
        pageNo: 1,
        selectedJobCardNo: null,
        perPageRecords: 1000,
        jobCardReportError: '',
    },
}

const jobCardReportSlice = createSlice({
    name: "jobCardReportSlice",
    initialState,
    reducers: {
        jobCardReportNormalLoadingPending: (state) => {
            state.jobCardReportNormalLists.isLoading = true;
            state.jobCardReportNormalLists.dataLoaded = false;
            state.jobCardReportNormalLists.recordCounts = 0;
            state.jobCardReportNormalLists.totalRecords = 0;
        },
        jobCardReportNormalLoadingSuccess: (state, { payload }) => {
            state.jobCardReportNormalLists.isLoading = false;
            state.jobCardReportNormalLists.data = payload.data;
            state.jobCardReportNormalLists.jobCardReportError = '';
            state.jobCardReportNormalLists.dataLoaded = true;
            state.jobCardReportNormalLists.recordCounts = payload.recordCounts;
            state.jobCardReportNormalLists.totalRecords = payload.totalRecords;
        },
        jobCardReportNormalLoadingFailed: (state, { payload }) => {
            state.jobCardReportNormalLists.isLoading = false;
            state.jobCardReportNormalLists.data = []
            state.jobCardReportNormalLists.jobCardReportError = payload;
            state.jobCardReportNormalLists.dataLoaded = true;
        },
        selectJobCardNo: (state, { payload }) => {
            const selectedJobCard = state.jobCardReportNormalLists.data.find((jc) => jc.jobCardId === payload);
            if (selectedJobCard) {
                state.jobCardReportNormalLists.selectedJobCardNo = selectedJobCard;
            }
        },

    }
});

const { reducer, actions } = jobCardReportSlice;

export const {
    jobCardReportNormalLoadingPending, jobCardReportNormalLoadingSuccess, jobCardReportNormalLoadingFailed, selectJobCardNo
}
    = actions;

export default reducer;